import { render, staticRenderFns } from "./AddStockin.vue?vue&type=template&id=32eac5b8&scoped=true"
import script from "./AddStockin.vue?vue&type=script&lang=js"
export * from "./AddStockin.vue?vue&type=script&lang=js"
import style0 from "./AddStockin.vue?vue&type=style&index=0&id=32eac5b8&prod&scoped=true&lang=css"
import style1 from "./AddStockin.vue?vue&type=style&index=1&id=32eac5b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eac5b8",
  null
  
)

export default component.exports